<app-menu-template3>
  <main class="container-fluid ">
    <article class="row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
      <section class="col-12 p-4 mt-3 mb-5">
        <div class="d-flex justify-content-between align-items-center">
          <header class="row form-group d-flex align-items-center">
            <figure class="m-auto">
              <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
                height="60">
            </figure>
            <div class="col row">
              <label class="text-dark h5 mb-0 font-weight-bold">Historial de solicitudes</label>
            </div>
          </header>
          <button type="button" class="btn btn-outline-primary h-" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </div>
        <div id="filtros" [ngbCollapse]="isCollapsed">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="formFiltroSolicitud" (ngSubmit)="onFiltrar()">
                <div class="row">
                  <div class="col-2 form-group" *ngIf="authService.getRolUser(soloConsultaNacional)">
                    <label class="small text-secondary mb-0">Cámara de Comercio</label>
                    <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                      <option class="" value="null" selected="true">
                        Seleccione
                      </option>
                      <option class="" *ngFor="let option of camarasLista; let i = index"
                        value="{{option?.codigo_camara}}" [selected]="false">
                        {{option?.desc_camara}}
                      </option>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0">Número RNT</label>
                    <input formControlName="codigo_rnt" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for="estado_rnt">Estado RNT</label>
                    <select id="estado_rnt" formControlName="estado_rnt_id" class="form-control custom-select">
                      <option value="">Seleccione</option>
                      <ng-container *ngFor="let item of estados_rnt">
                        <option [ngValue]="item.estado_rnt_id">{{item.descripcion}}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0">Radicado</label>
                    <input formControlName="numero_radicacion" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0">Matrícula</label>
                    <input formControlName="matricula" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0">NIT</label>
                    <input formControlName="nit" type="text" class="form-control form-control-sm">
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary mb-0" for="estado_solicitud">Estado solicitud</label>
                    <select id="estado_solicitud" formControlName="estado_solicitud_id"
                      class="form-control custom-select">
                      <option value="">Seleccione</option>
                      <ng-container *ngFor="let item of estados_solicitud">
                        <ng-container *ngIf="item.estado_solicitud_id !== 1">
                          <option [ngValue]="item.estado_solicitud_id">{{item.descripcion}}</option>
                        </ng-container>
                      </ng-container>
                    </select>
                  </div>
                  <div class="col-2 form-group">
                    <label class="small text-secondary" for="usuario_funcionario">Funcionario</label>
                    <div class="input-group">
                      <input readonly class="form-control" formControlName="usuario_funcionario"
                        aria-describedby="add_user">
                      <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary" (click)="onOpenModalFuncionario()"
                          id="add_user">+</button>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mt-3 ml-3">
                    <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                      (click)="reset()">Limpiar</button>
                    <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <app-tablas [page]="paginaActual" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
            [headers]="headers">
            <tr *ngFor="let item of solicitudes" class="small">
              <td>{{item.codigo_rnt}}</td>
              <td>{{item.descripcion_tipo_rnt}}</td>
              <td>{{item.descripcion_tipo_solicitud}}</td>
              <td>{{item.fecha_radicacion | date:'d/MMM/yyyy, h:mm a'}}</td>
              <td>{{item.descripcion_estado_solicitud}}</td>
              <td>{{item.razon_social}}</td>
              <td>{{item.fecha_ultima_actualizacion | date:'d/MMM/yyyy, h:mm a'}}</td>
              <td>{{item.matricula}}</td>
              <td>
                <a href="javascript:void(0)" (click)="modalDetalleProceso(item.rnt_id)">
                  <img src="../../../../../../../assets/icons/EYE.png" width="25">
                </a>
              </td>
              <td>{{item.nit}}</td>
              <td>{{item.numero_radicacion}}</td>
              <td>{{item.nombre_funcionario}}</td>
              <td>
                <ng-template #popContent>
                  <ng-container>
                    <button class="btn btn-outline-light border-0 text-left w-100" (click)="onAcciones(item)"
                      *ngIf="item.fecha_ultima_actualizacion">Ver
                      detalle</button>
                    <button class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onAnotacion(item)">Anotaciones
                    </button>
                  </ng-container>
                  <ng-container *ngIf="item.estado_rnt_id === estado_activo || item.estado_rnt_id === estado_activo_2">
                    <!-- <button class="btn btn-outline-light border-0 text-left w-100" (click)="onReporte(item)">Reporte
                      de registro</button> -->
                    <button class="btn btn-outline-light border-0 text-left w-100"
                      (click)="onCertificado(item)">Dercargar
                      Certificado</button>
                  </ng-container>
                </ng-template>
                <button type="button" class="btn btn-outline-secondary text-center" placement="bottom"
                  [ngbPopover]="popContent" popoverClass="bg-dark">
                  ..
                </button>
              </td>
            </tr>
          </app-tablas>
        </div>
      </section>
    </article>
  </main>
</app-menu-template3>